
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductPendrivesGrid extends Serenity.EntityGrid<ProductPendrivesRow, any> {
        protected getColumnsKey() { return ProductPendrivesColumns.columnsKey; }
        protected getDialogType() { return ProductPendrivesDialog; }
        protected getIdProperty() { return ProductPendrivesRow.idProperty; }
        protected getInsertPermission() { return ProductPendrivesRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductPendrivesRow.localTextPrefix; }
        protected getService() { return ProductPendrivesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}